export const formatPrice = (price: number) => {
	if (price === 0) return '0 Kč';

	if (!price) return '';

	return `${price / 100} Kč`;
};
